import { render, staticRenderFns } from "./AppResults.vue?vue&type=template&id=2fe3385e&scoped=true&"
import script from "./AppResults.vue?vue&type=script&lang=ts&"
export * from "./AppResults.vue?vue&type=script&lang=ts&"
import style0 from "./AppResults.vue?vue&type=style&index=0&id=2fe3385e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3385e",
  null
  
)

component.options.__file = "AppResults.vue"
export default component.exports